/**
 * b2bRoutes.jsx — Routes B2B (prestations freelance).
 *
 * Conditionnées au feature flag `FEATURES.B2B_ENABLED`. Pendant que Bruno
 * est salarié d'une moto-école, la partie freelance B2B est en pause.
 * Si désactivé, les routes redirigent vers la home pour éviter SEO mort.
 */
import React from 'react';
import { Route, Navigate } from 'react-router-dom';
import { withLayout } from '../lib/routeHelpers';
import FEATURES from '../config/features';
import PrestationsPro from '../pages/PrestationsPro';

export const B2BRoutes = () => (
  FEATURES.B2B_ENABLED ? (
    <>
      <Route path="/prestations-pro" element={withLayout(PrestationsPro)} />
      <Route path="/pro" element={<Navigate to="/prestations-pro" replace />} />
      <Route path="/auto-ecoles" element={<Navigate to="/prestations-pro" replace />} />
      <Route path="/moto-ecoles" element={<Navigate to="/prestations-pro" replace />} />
    </>
  ) : (
    <>
      <Route path="/prestations-pro" element={<Navigate to="/" replace />} />
      <Route path="/pro" element={<Navigate to="/" replace />} />
      <Route path="/auto-ecoles" element={<Navigate to="/" replace />} />
      <Route path="/moto-ecoles" element={<Navigate to="/" replace />} />
    </>
  )
);

export default B2BRoutes;
